import { Location } from 'history';

import { getLocationQuery } from '../../lib/url';
import { setLocalStorageItem } from '../../lib/webStorage';

export const INVITE_EMAIL_LOCAL_STORAGE_KEY = 'inviteEmailParams';

export const INVITE_EMAIL_PARAMS = [
    'utm_campaign',
    'utm_medium',
    'utm_source',
    'invited_type',
    'invited_edrpou',
];

export const saveInviteEmailParamsToLocalStorage = (location: Location) => {
    const query = getLocationQuery(location);
    const filteredInviteEmailParams = Object.entries(query).reduce(
        (result, [paramKey, paramValue]) => {
            if (INVITE_EMAIL_PARAMS.includes(paramKey)) {
                result[paramKey] = paramValue;
            }

            return result;
        },
        {} as Record<string, string>,
    );

    if (Object.keys(filteredInviteEmailParams).length) {
        setLocalStorageItem(
            INVITE_EMAIL_LOCAL_STORAGE_KEY,
            filteredInviteEmailParams,
        );
    }
};
